import { defineComponent as N, computed as i, ref as d, onMounted as p, watch as S, onBeforeUnmount as k, createElementBlock as v, openBlock as f, normalizeStyle as m, withDirectives as h, createElementVNode as z, renderSlot as B, normalizeClass as C, createTextVNode as V, toDisplayString as F, unref as $, vShow as R, nextTick as M } from "vue";
import { t as O } from "./tooltip-YeSRTnG0.js";
/* empty css                                                                       */
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = /* @__PURE__ */ N({
  __name: "TruncatedText",
  props: {
    limitDecimal: { default: 2 },
    type: { default: "string" },
    value: { default: void 0 },
    truncate: { default: "end" },
    maxWidth: { default: void 0 },
    tooltipTheme: { default: "arbo" },
    showTooltip: { type: Boolean, default: !0 }
  },
  setup(x) {
    const y = O, e = x, T = i(() => {
      if (e.showTooltip)
        return e.value;
      if (r.value && e.value)
        return e.value;
    }), _ = i(() => {
      if (e.value)
        return b(e.value);
    }), w = i(() => {
      if (e.maxWidth)
        return typeof e.maxWidth == "string" ? e.maxWidth : `${e.maxWidth}px`;
    }), b = (t) => {
      if (e.type === "string")
        return t;
      if (e.type === "number" && e.limitDecimal !== void 0) {
        const l = parseFloat(t);
        return isNaN(l) ? t : g(l, e.limitDecimal);
      }
      return t;
    };
    function E(t) {
      const l = getComputedStyle(t), a = parseFloat(l.width);
      let u = document.createElement("canvas");
      const s = u.getContext("2d");
      if (s) {
        s.font = `${l.fontSize} ${l.fontFamily}`;
        const W = s.measureText(t.innerText);
        return u = null, W.width > a;
      }
      return u = null, !1;
    }
    const r = d(!1), o = d(null), n = () => {
      M(() => {
        const t = o.value;
        let l = !1;
        t && (r.value = E(t) || l);
      });
    }, g = (t, l) => {
      const a = Number(t).toFixed(l).split(".");
      return a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), a.join(".");
    };
    p(() => {
      n();
    });
    const D = i(() => r.value ? [1e3, 0] : [0, 0]);
    S(
      [() => e.value],
      () => {
        n();
      },
      {
        deep: !0
      }
    );
    const c = new ResizeObserver(() => {
      n();
    });
    return p(() => {
      o.value && c.observe(o.value);
    }), k(() => {
      o.value && c.unobserve(o.value);
    }), (t, l) => (f(), v("div", {
      class: "truncated-text-wrapper",
      style: m({ maxWidth: w.value }),
      onHover: n
    }, [
      h(z("div", {
        class: "truncated-text",
        style: m({ direction: e.truncate === "start" ? "rtl" : "ltr" })
      }, [
        B(t.$slots, "content", {}, () => [
          h((f(), v("span", {
            ref_key: "valueRef",
            ref: o,
            class: C(["value", {
              truncated: r.value
            }])
          }, [
            V(F(_.value), 1)
          ], 2)), [
            [$(y), {
              content: T.value,
              delay: D.value,
              theme: e.tooltipTheme
            }]
          ])
        ], !0)
      ], 4), [
        [R, e.value && e.value.length > 0]
      ])
    ], 36));
  }
}), G = /* @__PURE__ */ j(A, [["__scopeId", "data-v-993cf403"]]);
export {
  G as default
};
